import {
    LayoutDashboard, Users, FileText, Receipt, Repeat, FileMinus, ArrowDownToLine,
    Building2, ShoppingCart, FileCheck2, ArrowUpFromLine, Landmark, Wallet, ArrowLeftRight,
    BookOpenCheck, BookText, ScrollText, Scale, CalendarDays, Lock,
    Calculator, Percent, FileSignature, Truck, Boxes, Warehouse, ArrowDownUp, PackageSearch,
    Briefcase, Clock4, BarChart3, FileBarChart2, FileSpreadsheet, ShieldCheck, History,
    Sparkles, Settings, BadgeIndianRupee, Building, Wand2, Globe, Filter, FileArchive, TrendingUp, Activity,
} from "lucide-react";

export const NAV = [
    {
        section: null,
        items: [{ label: "Dashboard", icon: LayoutDashboard, to: "/" }],
    },
    {
        section: "Sales",
        items: [
            { label: "Customers", icon: Users, to: "/sales/customers" },
            { label: "Estimates", icon: FileText, to: "/sales/estimates" },
            { label: "Delivery Challans", icon: Truck, to: "/sales/delivery-challans" },
            { label: "Invoices", icon: Receipt, to: "/sales/invoices" },
            { label: "Recurring Invoices", icon: Repeat, to: "/sales/recurring" },
            { label: "Credit Notes", icon: FileMinus, to: "/sales/credit-notes" },
            { label: "Payments Received", icon: ArrowDownToLine, to: "/sales/payments-received" },
        ],
    },
    {
        section: "Purchases",
        items: [
            { label: "Vendors", icon: Building2, to: "/purchases/vendors" },
            { label: "Purchase Orders", icon: ShoppingCart, to: "/purchases/orders" },
            { label: "Bills", icon: FileCheck2, to: "/purchases/bills" },
            { label: "Recurring Bills", icon: Repeat, to: "/purchases/recurring" },
            { label: "Vendor Credits", icon: FileMinus, to: "/purchases/vendor-credits" },
            { label: "Payments Made", icon: ArrowUpFromLine, to: "/purchases/payments-made" },
        ],
    },
    {
        section: "Banking",
        items: [
            { label: "Accounts", icon: Landmark, to: "/banking/accounts" },
            { label: "Reconciliation", icon: Wallet, to: "/banking/reconciliation" },
            { label: "Transfers", icon: ArrowLeftRight, to: "/banking/transfers" },
            { label: "Bank Rules", icon: Filter, to: "/banking/rules" },
        ],
    },
    {
        section: "Accounting",
        items: [
            { label: "Chart of Accounts", icon: BookOpenCheck, to: "/accounting/coa" },
            { label: "Manual Journals", icon: BookText, to: "/accounting/journals" },
            { label: "General Ledger", icon: ScrollText, to: "/accounting/ledger" },
            { label: "Trial Balance", icon: Scale, to: "/accounting/trial-balance" },
            { label: "Day Book", icon: CalendarDays, to: "/accounting/day-book" },
            { label: "Multi-Currency", icon: Globe, to: "/accounting/multi-currency" },
            { label: "Fiscal Periods", icon: Lock, to: "/accounting/fiscal-periods" },
        ],
    },
    {
        section: "Taxes",
        items: [
            { label: "GST Settings", icon: Calculator, to: "/taxes/gst-settings" },
            { label: "GST Returns", icon: Percent, to: "/taxes/gst-returns" },
            { label: "GSTR 2A/2B Recon", icon: Scale, to: "/taxes/gst-recon" },
            { label: "E-Invoicing", icon: FileSignature, to: "/taxes/e-invoicing" },
            { label: "E-Way Bills", icon: Truck, to: "/taxes/e-way-bills" },
            { label: "TDS / TCS", icon: Receipt, to: "/taxes/tds" },
        ],
    },
    {
        section: "Inventory",
        items: [
            { label: "Items", icon: Boxes, to: "/inventory/items" },
            { label: "Warehouses", icon: Warehouse, to: "/inventory/warehouses" },
            { label: "Stock Adjustments", icon: ArrowDownUp, to: "/inventory/adjustments" },
            { label: "Stock Transfers", icon: PackageSearch, to: "/inventory/transfers" },
            { label: "Fixed Assets", icon: Building2, to: "/inventory/fixed-assets" },
        ],
    },
    {
        section: "Projects",
        items: [
            { label: "Projects", icon: Briefcase, to: "/projects" },
            { label: "Timesheets", icon: Clock4, to: "/projects/timesheets" },
        ],
    },
    {
        section: "Reports",
        items: [
            { label: "Reports Hub", icon: BarChart3, to: "/reports" },
            { label: "Budgets", icon: Wallet, to: "/reports/budgets" },
            { label: "Cash Forecast", icon: TrendingUp, to: "/reports/cash-forecast" },
        ],
    },
    {
        section: "Intelligence",
        items: [
            { label: "AI Copilot", icon: Sparkles, to: "/copilot" },
        ],
    },
    {
        section: "Workspace",
        items: [
            { label: "Settings", icon: Settings, to: "/settings" },
            { label: "Import from Zoho", icon: FileArchive, to: "/settings/zoho-import" },
            { label: "Admin Metrics", icon: Activity, to: "/settings/admin-metrics", superAdminOnly: true },
        ],
    },
];

export const STATUS_COLORS = {
    paid: "bg-positive-soft text-positive border-positive/20",
    sent: "bg-muted text-foreground border-border",
    draft: "bg-muted text-muted-foreground border-border",
    overdue: "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/30 dark:text-red-300 dark:border-red-900",
    partial: "bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/30 dark:text-amber-300 dark:border-amber-900",
    void: "bg-muted text-muted-foreground line-through border-border",
    open: "bg-blue-50 text-blue-800 border-blue-200 dark:bg-blue-950/30 dark:text-blue-300 dark:border-blue-900",
    accepted: "bg-positive-soft text-positive border-positive/20",
    billed: "bg-muted text-muted-foreground border-border",
    cancelled: "bg-muted text-muted-foreground line-through border-border",
    generated: "bg-positive-soft text-positive border-positive/20",
};

export const REPORTS_CATALOG = [
    {
        group: "Financial Statements",
        items: [
            { name: "Profit & Loss", to: "/reports/profit-loss", desc: "Income & expenses for the period" },
            { name: "Balance Sheet", to: "/reports/balance-sheet", desc: "Snapshot of assets, liabilities & equity" },
            { name: "Cash Flow", to: "/reports/cash-flow", desc: "Movement of cash by activity" },
            { name: "Cash Forecast", to: "/reports/cash-forecast", desc: "13-week rolling projection of cash runway" },
            { name: "Budget vs Actuals", to: "/reports/budgets", desc: "Plan, track variance and stay accountable" },
        ],
    },
    {
        group: "Receivables",
        items: [
            { name: "AR Aging", to: "/reports/ar-aging", desc: "Outstanding receivables by bucket" },
            { name: "Sales by Customer", to: "/reports/sales-by-customer", desc: "Revenue contribution by customer" },
        ],
    },
    {
        group: "Payables",
        items: [
            { name: "AP Aging", to: "/reports/ap-aging", desc: "Outstanding payables by bucket" },
            { name: "Purchases by Vendor", to: "/reports/purchases-by-vendor", desc: "Spend split by vendor" },
        ],
    },
    {
        group: "Tax",
        items: [
            { name: "GST Summary", to: "/reports/gst-summary", desc: "Output, input, and net GST liability" },
            { name: "GSTR 2A/2B Reconciliation", to: "/taxes/gst-recon", desc: "Match portal data with purchase ledger" },
            { name: "TDS / TCS Summary", to: "/taxes/tds", desc: "Section-wise TDS + Form 26Q draft" },
        ],
    },
    {
        group: "Inventory",
        items: [
            { name: "Inventory Valuation", to: "/reports/inventory-valuation", desc: "Stock value at cost" },
        ],
    },
    {
        group: "Audit",
        items: [
            { name: "Audit Log", to: "/reports/audit-log", desc: "Immutable activity trail" },
        ],
    },
];
